/**
 * 管理后台权限节点定义（三段式）
 * - pc: PC后台权限（菜单路由 name）
 * - mobile: 移动端后台权限
 * - op: 操作权限
 */

/** PC后台权限多级树 */
export const PC_PERMISSION_TREE = [
  {
    id: 'pc:workbench',
    label: '工作台',
    children: [
      { id: 'Dashboard', label: '数据总览' }
    ]
  },
  {
    id: 'pc:user',
    label: '用户',
    children: [
      { id: 'MemberList', label: '用户管理' },
      { id: 'ResumeList', label: '务工方' },
      { id: 'CompanyList', label: '用工方' },
      { id: 'CompanyAuthList', label: '雇主认证' },
      { id: 'ReportList', label: '举报记录' }
    ]
  },
  {
    id: 'pc:business',
    label: '业务',
    children: [
      { id: 'OrderList', label: '订单审核' },
      { id: 'OrderCategoryList', label: '工种类目' },
      { id: 'OrderTemplateList', label: '发布模板' },
      { id: 'OrderProgressList', label: '订单进度' },
      { id: 'EvaluateList', label: '评价管理' }
    ]
  },
  {
    id: 'pc:wallet',
    label: '钱包',
    children: [
      { id: 'WalletList', label: '任务钱包' },
      { id: 'BonusList', label: '奖励金' },
      { id: 'WithdrawalList', label: '提现记录' }
    ]
  },
  {
    id: 'pc:activity',
    label: '活动',
    children: [
      { id: 'WalletRedList', label: '红包记录' },
      { id: 'SignInList', label: '签到记录' },
      { id: 'InviteList', label: '邀请记录' },
      { id: 'InviteConfig', label: '红包配置' },
      { id: 'TrainingRequestList', label: '培训需求' }
    ]
  },
  {
    id: 'pc:content',
    label: '内容',
    children: [
      { id: 'BannerList', label: '广告列表' },
      { id: 'BannerClassify', label: '广告位分类' }
    ]
  },
  {
    id: 'pc:chat',
    label: '对话',
    children: [
      { id: 'CsChatList', label: '零工客服对话' },
      { id: 'PeerChatList', label: '零工雇主对话' }
    ]
  },
  {
    id: 'pc:report',
    label: '数据报表',
    children: [
      { id: 'PlatformReport', label: '平台综合报表' },
      { id: 'DataImport', label: '数据归集导入' },
      { id: 'RightsReport', label: '维权管理报表' },
      { id: 'TrendReport', label: '求职趋势报表' },
      { id: 'DataReport', label: '数据报表(旧)' }
    ]
  },
  {
    id: 'pc:system',
    label: '系统',
    children: [
      { id: 'ManagerCate', label: '分类管理' },
      { id: 'ManagerDiy', label: '自定义配置' },
      { id: 'ManagerSys', label: '系统管理' },
      { id: 'WeNotify', label: '消息通知管理' },
      { id: 'SubSite', label: '驿站管理' }
    ]
  },
  {
    id: 'pc:admin',
    label: '系统管理员',
    children: [
      { id: 'AdminList', label: '管理员设置' },
      { id: 'AdminRole', label: '角色权限管理' }
    ]
  }
]

/** 移动端后台权限 */
export const MOBILE_PERMISSION_TREE = [
  { id: 'mobile:member', label: '会员管理' },
  { id: 'mobile:business', label: '业务管理' },
  { id: 'mobile:tools', label: '系统工具' }
]

/** 操作权限 */
export const OPERATION_PERMISSION_TREE = [
  { id: 'op:export', label: '导出数据' },
  { id: 'op:delete', label: '删除数据' },
  { id: 'op:editPackage', label: '编辑套餐' }
]

/** 收集所有叶子节点 id */
export function collectLeafIds(tree) {
  const ids = []
  function walk(nodes) {
    (nodes || []).forEach(node => {
      if (node.children && node.children.length) {
        walk(node.children)
      } else {
        ids.push(node.id)
      }
    })
  }
  walk(tree)
  return ids
}

export const ALL_PC_LEAF_IDS = collectLeafIds(PC_PERMISSION_TREE)
export const ALL_MOBILE_LEAF_IDS = collectLeafIds(MOBILE_PERMISSION_TREE)
export const ALL_OP_LEAF_IDS = collectLeafIds(OPERATION_PERMISSION_TREE)
export const ALL_LEAF_IDS = [...ALL_PC_LEAF_IDS, ...ALL_MOBILE_LEAF_IDS, ...ALL_OP_LEAF_IDS]
